import angular from 'angular';
import contractEntering from './contractEntering';
import contractManagement from './contractManagement';
import imageManagement from './imageManagement';

export default angular
  .module('input.electronImage', [
    contractEntering,
    contractManagement,
    imageManagement,
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('input.electronImage', {
        abstract: true,
        url: '/electronImage',
        template: '<div ui-view></div>',
      });
    },
  ]).name;



// WEBPACK FOOTER //
// ./src/app/input/electronImage/index.js